import { render, staticRenderFns } from "./MatchSeting.vue?vue&type=template&id=20037478&scoped=true"
import script from "./MatchSeting.vue?vue&type=script&lang=js"
export * from "./MatchSeting.vue?vue&type=script&lang=js"
import style0 from "./MatchSeting.vue?vue&type=style&index=0&id=20037478&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20037478",
  null
  
)

export default component.exports